module.exports = __webpack_public_path__ + "img/portrait-074.8cd4a727.jpg";